import { hash } from 'ohash'
import { getApprovalMaxAmount, getApprovalOption } from '~/libs/approval-helper'
import { getOfferKey, normalizeOffer, getAcceptedOffer } from '~/libs/offer-helper'

export const ATTRIBUTE_ALIAS = 'lastSeenFinancingOptionsHash'

export function getOptionsHash(availableOptions, activeDeal = null, initialChange = null) {
  if (typeof initialChange !== 'function') {
    throw new Error('Approval initial change property is required for calculations')
  }

  const acceptedOffer = activeDeal ? getAcceptedOffer(activeDeal) : null
  const options = acceptedOffer ? [normalizeOffer(acceptedOffer, activeDeal)] : availableOptions
  const stage = acceptedOffer ? 'accepted' : 'comparison'

  if (!options || !options.length) {
    return ''
  }

  const normalizedData = options.map((option) => {
    const approvalOption = !option.isStaticOffer ? getApprovalOption(option, initialChange) : {}
    const amount = Number(option.isStaticOffer ? option.amount : getApprovalMaxAmount(option, approvalOption))

    return {
      id: option.id,
      key: getOfferKey(option),
      amount,
      created: option.created ?? null,
      modified: option.modified ?? null,
    }
  })

  return hash({
    stage,
    options: normalizedData
  })
}
